import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import {
  localeSelector,
  organizationNameSelector,
  userNamesSelector,
  userIdSelector,
  isBetaUserSelector,
} from '@/domain/env';
// eslint-disable-next-line no-restricted-syntax
import { loadedDataCompanyNameSelector } from '@/domain/companies';
import { currentConnectedERPselector } from '@/domain/settings';
import openFreshDeskChat from '@/lib/freshdeskChat/openFreshDeskChat';

const useOpenChat = () => {
  const email = useSelector(userIdSelector);
  const userName = useSelector(userNamesSelector);
  const organizationName = useSelector(organizationNameSelector);
  // The support chat describes the company whose data the store holds — the last company
  // visited, also on pages that name none — so that its name and its ERP belong together.
  // A known compromise: the chat should be told which company the user is asking about.
  const currentCompanyName = useSelector(loadedDataCompanyNameSelector);
  const currentConnectedERP = useSelector(currentConnectedERPselector);
  const locale = useSelector(localeSelector);
  const isBetaUser = useSelector(isBetaUserSelector);
  const { labelOptions } = useTheme();

  return useCallback(() => {
    const { name, supportEmail } = labelOptions;
    if (name !== 'AlPrime') {
      openFreshDeskChat({
        email,
        organizationName,
        currentCompanyName,
        currentConnectedERP,
        userName,
        locale,
        isBetaUser,
      });
    } else {
      window.location = `mailto:${supportEmail}`;
    }
  }, [labelOptions, email, organizationName, currentCompanyName, currentConnectedERP, userName, locale, isBetaUser]);
};

export default useOpenChat;
